import type { FC, ReactNode } from 'react';

import { Box } from '@packages/shared';

import { LinkedLogo } from './LinkedLogo';

export type HeaderToolbarProps = {
  children?: ReactNode;
};

/**
 * An html header with a shop logo on the left, and space for additional header contents to the right
 */
export const HeaderToolbar: FC<HeaderToolbarProps> = ({ children }) => (
  <Box
    component="header"
    sx={{
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: [0, 0, 0, 6.5],
      px: [1, 1, 1, 0],
    }}
  >
    <LinkedLogo />
    {children}
  </Box>
);
